import { Controller, useForm, type SubmitHandler } from "react-hook-form"
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import type { MunicipalityAdministrationSharingFormInput } from "@/types"
import { useUpdateAdministrationSharing } from "@/hooks/api/use-municipality"

const MunicipalityAdministrationSharingForm = ({
    municipalityId,
    isVisibleForCollectionCompany,
    closeCallback,
} : {
    municipalityId: number,
    isVisibleForCollectionCompany: boolean,
    closeCallback?: () => void,
}) => {

    const initialValues: MunicipalityAdministrationSharingFormInput = {
        isVisibleForCollectionCompany,
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        watch,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(() => reset(initialValues))

    const mutation = useUpdateAdministrationSharing(
        municipalityId,
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
        },
    )

    const onSubmit: SubmitHandler<MunicipalityAdministrationSharingFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    const newIsVisible = watch('isVisibleForCollectionCompany')

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText="Upravit"
            heading="Upravit sdílení sekce správy obce se svozovou společností"
            disableSave={isVisibleForCollectionCompany === newIsVisible}
        >
            <Box mx="auto" mb={1}>
                <FormControlLabel control={
                    <Controller
                        name="isVisibleForCollectionCompany"
                        control={control}
                        render={({ field }) => <Switch
                            {...field}
                            value={!!field.value}
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />}
                    />
                } label="Sdílení sekce správy se svozovou společností" />
            </Box>
        </Form>
    )
}

export default MunicipalityAdministrationSharingForm
